module.exports = __webpack_public_path__ + "img/serviceCases.c8c535f.png";